import { render } from "./memory.vue?vue&type=template&id=2ec84a7f&scoped=true"
import script from "./memory.vue?vue&type=script&lang=js"
export * from "./memory.vue?vue&type=script&lang=js"

import "./memory.vue?vue&type=style&index=0&id=2ec84a7f&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec84a7f"]])

export default __exports__